import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import Modal from '#components/m/Modal'
import NachweisDetailEdit from '#components/o/NachweisDetail/NachweisDetailEdit'
import {usePermissions} from '#hooks/usePermissions'

export function NachweisModal({trigger, nachweisId, startDate}) {
  const permissions = usePermissions()
  return (
    <Modal hasCloseIcon trigger={trigger} modifier="nachweis-preview">
      <NachweisDetailEdit nachweisId={nachweisId} startDate={startDate} permissions={permissions} isModalView />
    </Modal>
  )
}

NachweisModal.propTypes = {
  trigger: PropTypes.node,
  nachweisId: PropTypes.string,
  startDate: PropTypes.string,
}

function mapStateToProps(state) {
  return {
    startDate: state.authentication.startDate,
  }
}

export default connect(mapStateToProps)(NachweisModal)
